<template>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNotifications" aria-labelledby="offcanvasNotificationsLabel">
        <div class="offcanvas-header">
            <h2 class="offcanvas-title" id="offcanvasNotificationsLabel">{{ t('title') }}</h2>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
            <div>
                <button v-if="notifications.length !== 0" v-on:click="markReadAll" class="btn btn-primary btn-sm" type="button">{{ t('mark_all') }}</button>
            </div>
            <div>
                <p v-if="notifications.length == 0" class="small text-reset">{{ t('none') }}</p>
            </div>

            <div class="d-flex flex-column align-items-stretch flex-shrink-0 bg-white" style="width: 380px;">
                <div class="list-group list-group-flush border-bottom scrollarea">
                    <div v-for="n in notifications" class="list-group-item list-group-item-action py-3 lh-tight">
                        <div class="d-flex w-100 align-items-center justify-content-between">
                            <strong class="mb-1">{{ n.title }}</strong>
                            <small>{{ n.created_at }}</small>
                        </div>
                        <div v-if="n.date != ''" class="col-10 mb-1 small"><i class="fa-light fa-calendar-days"></i> <strong>{{ n.date }}</strong></div>
                        <div class="col-10 mb-1 small">{{ n.body }}</div>
                        <div class="hr"></div>
                        <div class="hstack gap-3"><a class="btn btn-outline-primary btn-sm" v-bind:href="n.linkUrl">{{ n.linkText }}</a> <button v-on:click="markRead(n.id)" class="link-secondary ms-auto btn btn-link btn-sm">{{ t('delete') }} <i class="fa-light fa-xmark"></i></button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const fallbackTranslations = {
    title: 'Notifications',
    mark_all: 'Clear all notifications',
    none: 'No notifications.',
    delete: 'Delete notification',
};

export default {
    data () {
        return {
            notifications: [],
        };
    },

    methods: {
        fetchNotifications: function() {
            axios.get(this.fetch_data_url)
                .then((response) => {
                    this.notifications = response['data'];
            });
        },

        t(key) {
            if (this.translations && Object.prototype.hasOwnProperty.call(this.translations, key)) {
                return this.translations[key];
            }

            return fallbackTranslations[key] || key;
        },

        markRead: function(id) {
            axios.post("/notifications/mark_read", {
                id: id
            })
            .then((response) => {
                const data = response.data;

                if (data == true) {
                    delete this.notifications[id];
                }
                // Emit event that notifications count needs updating (uses developit/mitt)
                this.eventBus.emit('update_notication_count');
            });
        },

        markReadAll: function() {
            axios.post("/notifications/mark_read_all", {})
            .then((response) => {
                const data = response.data;

                if (data == true) {
                    this.notifications = [];
                }
                // Emit event that notifications count needs updating (uses developit/mitt)
                this.eventBus.emit('update_notication_count');
            });
        }
    },

    props: {
        fetch_data_url: {
            type: String,
            required: true,
        },
        translations: {
            type: Object,
            default: () => ({}),
        },
    },

    created() {
        this.fetchNotifications();
    },
}
</script>
